import DamageAdjustment from "./DamageAdjustment";

export default DamageAdjustment;
export { DamageAdjustment };
